<div sbbDialogTitle>
  <ng-container>
    {{
      "app.view.dialogs.filterable-labels-dialog.filterable-label-dialog-component.edit-filterable-labels"
        | translate: {element: dialogTitle}
    }}
  </ng-container>
</div>
<div sbbDialogContent sy>
  <sbb-filterable-label-form [model]="formModel"></sbb-filterable-label-form>
</div>
<div sbbDialogActions>
  <button
    class="FunctionButton"
    tabindex="-1"
    mode="icon"
    (click)="onTransferClicked()"
    [title]="
      'app.view.dialogs.filterable-labels-dialog.filterable-label-dialog-component.transfer-to-all-visible'
        | translate
    "
  >
    <sbb-icon
      svgIcon="arrow-change-horizontal-medium"
      height="13px"
      width="13px"
      aria-hidden="false"
    ></sbb-icon>
  </button>
  <button
    class="FunctionButton"
    tabindex="-1"
    mode="icon"
    (click)="onDeleteClicked()"
    [title]="
      'app.view.dialogs.filterable-labels-dialog.filterable-label-dialog-component.delete-from-all-visible'
        | translate
    "
  >
    <sbb-icon svgIcon="trash-medium" height="13px" width="13px" aria-hidden="false"></sbb-icon>
  </button>
</div>
